import { Search, ShoppingCart, ArrowRight } from "lucide-react";
import { cn } from "@/lib/utils";
import { TRY } from "@/lib/format";

// Mobil: tek pano görünümü — "Ürün Ara" / "Sepet" sekmeleri (terminal üst çubuğunun hemen altında)
export function MobileViewTabs({ view, onView, count, grand, restricted, unread = 0 }) {
  const Tab = ({ k, Icon, label, children, tid }) => {
    const on = view === k;
    return (
      <button type="button" role="tab" aria-selected={on} onClick={() => onView(k)} data-testid={tid}
        className={cn("h-11 rounded-xl inline-flex items-center justify-center gap-1.5 text-[13px] font-bold transition-all active:scale-[0.98]",
          on ? "bg-card text-foreground shadow-sm ring-1 ring-border" : "text-muted-foreground")}>
        <Icon className={cn("h-4 w-4", on && "text-primary")} />{label}{children}
      </button>
    );
  };
  return (
    <div className="shrink-0 grid grid-cols-2 gap-1 p-1.5 bg-muted/70 border-b border-border" role="tablist" data-testid="pos-mobile-tabs">
      <Tab k="search" Icon={Search} label="Ürün Ara" tid="pos-mobile-tab-search" />
      <Tab k="cart" Icon={ShoppingCart} label="Sepet" tid="pos-mobile-tab-cart">
        <span key={count} className={cn("tnum rounded-full px-1.5 py-px text-[11px] animate-in zoom-in-50 duration-300", count ? "bg-primary text-white" : "bg-muted text-muted-foreground")} data-testid="pos-mobile-cart-count">{count}</span>
        {!restricted && count > 0 && <span className="tnum text-[11px] text-muted-foreground font-semibold">{TRY(grand)}</span>}
        {unread > 0 && <span className="h-2.5 w-2.5 rounded-full bg-red-600 animate-ping" data-testid="pos-mobile-cart-unread" />}
      </Tab>
    </div>
  );
}

// Mobil arama görünümünün altında sabit sepet çubuğu: ürün eklenince kalem sayısı + toplam anında güncellenir → "Sepete Git"
export function MobileCartBar({ count, grand, restricted, onOpen }) {
  return (
    <div className="shrink-0 border-t border-border bg-[#0B192C] text-white px-3 pt-2 pb-[max(0.5rem,env(safe-area-inset-bottom))]" data-testid="pos-mobile-cart-bar">
      <button type="button" onClick={onOpen} className="w-full h-12 flex items-center gap-3 rounded-xl px-3 bg-white/5 active:bg-white/10 transition-colors" data-testid="pos-mobile-cart-open">
        <span className="relative grid h-9 w-9 shrink-0 place-items-center rounded-lg bg-white/10">
          <ShoppingCart className="h-5 w-5 text-[#FF8A4C]" />
          {count > 0 && <span key={count} className="absolute -top-1.5 -right-1.5 min-w-[18px] h-[18px] rounded-full bg-[#EA5820] text-[10px] font-black grid place-items-center px-1 tnum animate-in zoom-in-50 duration-300">{count}</span>}
        </span>
        <span className="flex-1 min-w-0 text-left leading-tight">
          <span className="block text-[10px] font-bold uppercase tracking-[0.18em] text-white/50">Sepet</span>
          <span className="block text-[13px] font-semibold truncate">{count ? `${count} kalem · Sepete Git` : "Sepet boş — ürün ekleyin"}</span>
        </span>
        {!restricted && count > 0 && <span key={`g${grand}`} className="font-head font-black tnum text-lg text-[#FF8A4C] animate-in fade-in duration-300" data-testid="pos-mobile-cart-grand">{TRY(grand)}</span>}
        <ArrowRight className="h-5 w-5 text-white/60 shrink-0" />
      </button>
    </div>
  );
}
